/**
 * File anchor-nav.js
 * 
 * Makes anchor nav scrolly
 *
 * @package wildrivers
 */
export function anchorNav() {

    const anchorNav = document.querySelectorAll(".wildrivers-anchor-nav");

    anchorNav?.forEach( (navList) => {
        const linkContainer = navList.querySelector(".anchor-link-container");
        const linkList      = linkContainer?.querySelector("ul") ?? null;
        if ( linkList && linkContainer ) {
            const buttonLeft = linkContainer.querySelector(".scroll-arrow.left")
            const buttonRight = linkContainer.querySelector(".scroll-arrow.right");
            buttonLeft.addEventListener("click", function() {
                linkList.scrollBy({
                    left: -200,
                    behavior: "smooth"
                });
            });
            buttonRight.addEventListener("click", function() {
                linkList.scrollBy({
                    left: 200,
                    behavior: "smooth"
                });
            });

            const adjustScroll = function() {
                let leftPosition = linkList.scrollLeft;
                let innerWidth = linkList.scrollWidth - linkList.clientWidth;

                buttonLeft.style.display = leftPosition > 0 ? "flex" : "none",
                buttonRight.style.display = leftPosition < innerWidth - 1 ? "flex" : "none";

                var thisLinkContainer = linkContainer;
                leftPosition <= 0 ? thisLinkContainer.classList.add("hide-left") : thisLinkContainer.classList.remove("hide-left"),
                leftPosition >= innerWidth - 1 ? thisLinkContainer.classList.add("hide-right") : thisLinkContainer.classList.remove("hide-right");
            };

            const adjustOverflow = function() {
                var leftPosition = linkList.scrollWidth > linkList.clientWidth;
                linkContainer.classList.toggle("is-overflowing", leftPosition),
                adjustScroll();
            };

            linkList.addEventListener("scroll", adjustScroll);

            window.addEventListener("resize", adjustOverflow);
            
            "ResizeObserver" in window && new ResizeObserver(adjustOverflow).observe(linkList),
            adjustOverflow();
        }
    });
}
